import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPackage } from '../redux/features/packages/packageSlice';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { getFrequencySuffix, getPlanOptions } from '../utils/planAdapter';

const PackageForm = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.package.packages);
  const navigate = useNavigate();
  const { personalDetail } = useSelector((state) => state.signup);

  useEffect(() => {
    const fetchData = async () => {
      dispatch(fetchPackage());
    };
    fetchData();
  }, []);

  const handlePlan = (data) => {
    localStorage.setItem('selectedPlan', JSON.stringify(data));
    if (
      personalDetail?.subscriptions?.length === 0 &&
      Cookies.get('isSubscribed') === undefined
    ) {
      localStorage.setItem('joinEmail', personalDetail?.email);
      navigate('/plan-checkout');
    } else {
      navigate('/joinform');
    }
  };

  return (
    <>
      <div className="choose-plans-description">
        {data ? (
          <>
            {data.map((item, index) => (
              <div className="plans-price" key={index}>
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="logo-form">
                        <img
                          src="../../images/footer-logo.webp"
                          alt=""
                          className="img-fluid"
                        />
                        <p className="plan-features">PLAN FEATURES</p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      {getPlanOptions(item, { includePrepaid: false })
                        ?.filter((option) => option.frequency !== 'one_time')
                        .map((option, optionIndex, allOptions) => (
                          <div
                            className="associate-price"
                            key={`${option.id}-${optionIndex}`}
                          >
                            <h3 className="coverage">
                              {option.package_name || item.name}
                            </h3>
                            <div>
                              <p className="monthly-price">
                                <span>
                                  <sup className="currency-symbol">$</sup>
                                </span>
                                {Math.trunc(option.price)}
                                <span className="month">
                                  {getFrequencySuffix(option.frequency)}
                                </span>
                              </p>
                              {optionIndex !== allOptions.length - 1 && (
                                <div className="divider">
                                  <hr className="hr-line" />
                                  <span className="associate-price-divider">
                                    Or
                                  </span>
                                  <hr className="hr-line" />
                                </div>
                              )}
                            </div>
                          </div>
                        ))}
                    </div>

                    <div className="table-list-user-plan">
                      <table className="table">
                        <tbody>
                          {item.features?.map((feature) => (
                            <tr className="table-list" key={feature.id}>
                              <td className="table-title">
                                <p className="table-heading">{feature.name}</p>
                              </td>
                              <td className="table-image">
                                <img
                                  src="../../images/right-check.svg"
                                  alt="right-check"
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>

                      <h3 className="options">{item.name}</h3>
                      <table className="table">
                        <tbody>
                          {getPlanOptions(item, { includePrepaid: true })
                            .filter((option) => option.is_prepaid)
                            .map((option, optionIndex) => (
                              <tr
                                className="coverage-table"
                                key={`${option.id}-${optionIndex}`}
                              >
                                <td className="table-plan">
                                  <h4>{option.package_name || item.name}</h4>
                                </td>
                                <td className="table-monthly">
                                  <p className="yearly-price">
                                    ${Math.trunc(option.price)}
                                    {getFrequencySuffix(option.frequency)}
                                  </p>
                                </td>
                              </tr>
                            ))}
                          <tr className="plan-button">
                            <td className="table-plan"></td>
                            <td className="correct-image-1">
                              {item?.pricing_summary?.one_time !== null &&
                                item?.pricing_summary?.one_time !==
                                  undefined && (
                                  <p className="fee">
                                    **One-time $
                                    {item?.pricing_summary?.one_time}{' '}
                                    Registration Fee**
                                  </p>
                                )}

                              <a
                                className="button-golden"
                                onClick={() => handlePlan(item)}
                              >
                                select plan
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </>
        ) : (
          <p>Loading...</p>
        )}
      </div>
    </>
  );
};

export default PackageForm;
